(function () {
  var root = document.querySelector('[data-account-status]');
  if (!root) return; // not logged in — section renders nothing for anonymous visitors

  // Phase 4D.15 App Proxy pilot: no customerId/issuedAt/token to read or
  // send. Shopify verifies who is logged in server-side and appends a
  // trusted logged_in_customer_id to this same-origin request itself —
  // this file has no identity of its own to supply.
  var PROXY_PATH = root.getAttribute('data-as-proxy-path');

  var planLabel = root.querySelector('[data-as-plan-label]');
  var creditsLabel = root.querySelector('[data-as-credits-label]');

  if (!PROXY_PATH) return;

  function formatDate(isoDateStr) {
    if (!isoDateStr) return '';
    try {
      var d = new Date(isoDateStr + 'T00:00:00Z');
      return d.toLocaleDateString(undefined, { month: 'long', day: 'numeric', timeZone: 'UTC' });
    } catch (e) {
      return isoDateStr;
    }
  }

  fetch(PROXY_PATH)
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.tier === 'ai_plus' && data.credits) {
        planLabel.textContent = 'AI+';
        creditsLabel.textContent = data.credits.remaining + ' / ' + data.credits.total + ' credits · Renews ' + formatDate(data.credits.renewsOn);
        root.classList.add('studio-account-status--ai-plus');
        root.hidden = false;
      } else if (data.tier === 'free') {
        planLabel.textContent = 'Free Plan';
        creditsLabel.innerHTML = '<a href="/products/modern-studio-ai-plus" class="studio-account-status__upgrade-link">Upgrade to AI+ →</a>';
        root.classList.add('studio-account-status--free');
        root.hidden = false;
      }
      // Any error/unexpected shape (including the App Proxy not being
      // configured/released yet during the pilot period, which would
      // surface as a 404): stay hidden rather than show something broken.
    })
    .catch(function () {
      // Fails silently — this is a status display, not a gate. A network
      // hiccup, or the App Proxy not being live yet during the pilot,
      // shouldn't show an alarming error on the Studio landing page.
    });
})();
